<template>
  <div class="mt-5 pt-5"></div>
  <div ref="message" class="col-12 col-md-11 col-lg-10 col-xl-9 cert-announcement my-auto mx-auto py-4 px-5">
    <strong style="font-size: 1.2rem">Page not found</strong>
    <strong>
      <router-link :to="{path: '/home'}" style="width: fit-content">
        <micon icon="arrow_back" class="material-icons-outlined"/>
        <span style="margin-left: 8px">Return to Home Page</span>
      </router-link>
    </strong>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
